export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_CANCEL = 'FETCH_CANCEL';
export const FETCH_ON_UPLOAD_PROGRESS = 'FETCH_ON_UPLOAD_PROGRESS';
export const FETCH_ON_UPLOAD_SUCCESS = 'FETCH_ON_UPLOAD_SUCCESS';
